import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

const WhyChooseMowebAgriculture = () => {
    return (
        <div className="section-py">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10 pb-10">
                        <h2 className="mb-0" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Why Choose Moweb for Agriculture Software Development?
                        </h2>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-2 mb-10">
                    <div className="card p-5 md:p-5 lg:p-30 bg-white dark:bg-black rounded-10 border hover:border-[#00B050]">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/agriculture-industry/svg/ic-proven-agtech.svg"
                                width={36}
                                height={36}
                                alt="proven-agtech"
                            />
                        </div>
                        <p className="fs-lg font-bold mb-3 text-primary_one">Proven AgTech Experience</p>
                        <p className="fs-md mb-0">
                            10+ years of custom agriculture software development across farming, livestock, and aquaculture
                            sectors.
                        </p>
                    </div>
                    <div className="card p-5 md:p-5 lg:p-30 bg-white dark:bg-black rounded-10 border hover:border-[#00B050]">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/agriculture-industry/svg/ic-tangible-business.svg"
                                width={36}
                                height={36}
                                alt="tangible business"
                            />
                        </div>
                        <p className="fs-lg font-bold mb-3 text-primary_one">Tangible Business Impact</p>
                        <p className="fs-md mb-0">
                            Helped clients reduce input waste by up to 28% and cut manual labor by 1,500+ hours per season.
                        </p>
                    </div>
                    <div className="card p-5 md:p-5 lg:p-30 bg-white dark:bg-black rounded-10 border hover:border-[#00B050]">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/agriculture-industry/svg/ic-ai-iot.svg"
                                width={36}
                                height={36}
                                alt="AI + IoT Expertise"
                            />
                        </div>
                        <p className="fs-lg font-bold mb-3 text-primary_one">AI + IoT Expertise</p>
                        <p className="fs-md mb-0">
                            We specialize in integrating smart devices, drones, and predictive models into real-world farming
                            systems.
                        </p>
                    </div>
                    <div className="card p-5 md:p-5 lg:p-30 bg-white dark:bg-black rounded-10 border hover:border-[#00B050]">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/agriculture-industry/svg/ic-flexible-engagement.svg"
                                width={36}
                                height={36}
                                alt="flexible engagement"
                            />
                        </div>
                        <p className="fs-lg font-bold mb-3 text-primary_one">Flexible Engagement Models</p>
                        <p className="fs-md mb-0">
                            Whether you&apos;re an early-stage startup or an established agribusiness, we scale with your goals
                            and timelines.
                        </p>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10">
                        <h2 className="mb-3" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Build the Future of Farming—With a Leading Agriculture Software Development Company
                        </h2>
                        <p className="mb-3">
                            Work with a top agriculture software development company that understands both tech and terrain.
                        </p>
                        <div>
                            <Link
                                href="/contact-us"
                                className="btn btn-primary bg-[#00B050] border-[#00B050] hover:border-[#00B050]"
                            >
                                {'Hire AgTech Developers'}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhyChooseMowebAgriculture;
